import {CreateView} from '../../src/components/_views/configurable/CreateView';
import {withRouterApi} from '../../src/HOCs/withRouterApi';
import {FormViewProps} from '../../src/@types/components/FormViewProps';
import ClientForm from './ClientForm';

export class ClientCreateForm extends CreateView {
    protected getFormComponent() {
        return ClientForm;
    }
}

export default ClientCreateForm.getStoreConnector()(withRouterApi<FormViewProps>(ClientCreateForm));
